/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Summary_OpenInputs */

const cs_deal_payments_summary_open = /** @type {(inputs: Deal_Payments_Summary_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřené`)
};

const en_deal_payments_summary_open = /** @type {(inputs: Deal_Payments_Summary_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Deal_Payments_Summary_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_summary_open = /** @type {((inputs?: Deal_Payments_Summary_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Summary_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_summary_open(inputs)
	return cs_deal_payments_summary_open(inputs)
});